import React from "react";
import ReactTooltip from "react-tooltip";

export default function Tooltip(props) {
  const { ...rest } = props;
  return (
    <ReactTooltip
      backgroundColor="#2F4050"
      padding="3px 8px"
      className="tooltip-inner"
      effect="solid"
      {...rest}
    />
  );
}
